import { render, staticRenderFns } from "./Budget.vue?vue&type=template&id=08400dae&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08400dae",
  null
  
)

export default component.exports